import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/** Строка товара в CI/PL — колонки обоих документов лежат вместе. */
export interface SupplierShipmentDocumentItem {
  productId?: number;
  description?: string;
  hsCode?: string;
  quantity?: number;
  unit?: string;
  unitPrice?: number;
  amount?: number;
  cartons?: number;
  netWeightKg?: number;
  grossWeightKg?: number;
  volumeCbm?: number;
}

/** Данные для Commercial Invoice + Packing List по перевозке. */
export interface SupplierShipmentDocument {
  id?: number;
  calculationId: number;
  /** false — это автозаполненный черновик, ещё ни разу не сохранённый поставщиком. */
  saved: boolean;

  sellerName?: string;
  sellerAddress?: string;
  buyerName?: string;
  buyerAddress?: string;
  /** Пусто — значит «Same as Seller» */
  shipperName?: string;
  shipperAddress?: string;
  /** Пусто — значит «Same as Buyer» */
  consigneeName?: string;
  consigneeAddress?: string;

  invoiceNumber?: string;
  invoiceDate?: string;
  yourOrderNo?: string;
  ourOrderNo?: string;
  documentaryCreditNo?: string;
  issuedByBank?: string;
  vesselAircraft?: string;
  fromLocation?: string;
  toLocation?: string;
  countryOfOrigin?: string;
  termsOfDelivery?: string;
  currencyCode?: string;

  items: SupplierShipmentDocumentItem[];
}

@Injectable({
  providedIn: 'root'
})
export class SupplierDocumentService {
  private apiUrl = '/cargo/api/customs-calculations';

  constructor(private http: HttpClient) {}

  get(calculationId: number): Observable<SupplierShipmentDocument> {
    return this.http.get<SupplierShipmentDocument>(`${this.apiUrl}/${calculationId}/supplier-document`);
  }

  save(calculationId: number, document: SupplierShipmentDocument): Observable<SupplierShipmentDocument> {
    return this.http.put<SupplierShipmentDocument>(`${this.apiUrl}/${calculationId}/supplier-document`, document);
  }
}
